import { CollectionView } from 'backbone.marionette';
import Preloader from '../../../utils/Preloader';
import Radio from 'backbone.radio';
import _ from 'lodash';
import { RankingsEmptyRow } from '../RankingsEmptyRow';
import moment from "moment";

const rankingsChannel = Radio.channel('Rankings');
const globalChannel = Radio.channel('global');
const months = [
	{ val: 1, name: "January" },
	{ val: 2, name: "February" },
	{ val: 3, name: "March" },
	{ val: 4, name: "April" },
	{ val: 5, name: "May" },
	{ val: 6, name: "June" },
	{ val: 7, name: "July" },
	{ val: 8, name: "August" },
	{ val: 9, name: "September" },
	{ val: 10, name: "October" },
	{ val: 11, name: "November" },
	{ val: 12, name: "December" },
];


export class CoreRankingsTable extends CollectionView {
	get childView() {
		throw new Error("Need set childView for child CoreRankings class");
	}

	get emptyView() {
		let actual_round = this.rounds.actual;

		if (actual_round) {
			if (
				actual_round.get('id')===1 &&
				actual_round.get('status')==='scheduled'
			) {
				return false;
			}
			else {
				return RankingsEmptyRow;
			}
		}
	}

	get childViewOptions() {
		return {
			current_round: this.model.get('round'),
			rounds: this.rounds,
			is_month_view: this.model.get('month') !== ''
		};
	}

	async initialize() {
		this.liveScoresIntervalId = null;

		this.rounds = this.getOption('rounds');
		this.squads = this.getOption('squads');
		this.rankings_limit = 50;
		this.squad_id = this.getOption('squad_id');

		this.initListeners();

		Preloader.show();
		await this.fetchRounds();
		await this.fetchData();
		Preloader.hide();

		this.updateModel()
			.updateCollection()
			.initLiveScores()
			.render();
	}

	initListeners() {
		this.listenTo(rankingsChannel, 'rankings:update', this.updateRankings);
		this.listenTo(this.collection, 'response:overall:teams:count', this.isShowMoreButton);
		this.listenTo(globalChannel, 'click:load:more', this.showMore);
		return this;
	}

	initLiveScores() {
		this.current_round = this.rounds.actual;

		if (this.current_round.get('status')==='active') {
			this.subscribeToLiveUpdates();
		}
		else {
			clearInterval(this.liveScoresIntervalId);
		}

		return this;
	}

	subscribeToLiveUpdates() {
		if (this.liveScoresIntervalId) {
			return this;
		}

		const updateInterval = 1000 * 60 * 5;
		this.liveScoresIntervalId = setInterval(() => this.liveUpdates(), updateInterval);
	}

	liveUpdates() {
		this.model.set('offset', 0);
		this.fetchRounds();
		this.fetchData().then(() => {
			this.updateModel()
				.updateCollection()
				.initLiveScores()
				.render();
		});

		return this;
	}

	updateRankings(data = {}, remove = true) {
		if (data.round && data.round==='') {
			data.round = this.rounds.actual.get('id');
		}

		let offset = data.offset ? data.offset : 0;
		this.model.set({ offset });
		Preloader.show();

		this.collection
			.setOverallLadderUrl()
			.fetch({
				data,
				remove: remove,
				sort: false
			}).then(response => {
				let count_teams = response.result.length;
				this.isShowMoreButton(count_teams);
				Preloader.hide();
			});
	}

	fetchRounds() {
		return Promise.all([
			this.rounds.fetch()
		]);
	}

	fetchData() {
		const data = this.squad_id ? { club: this.squad_id } : {};
		return Promise.all([
			this.collection
				.showOverallLadder(data),
			this.squads.fetch()
		]);
	}

	getMonthsArray(rounds) {
		if (!rounds || _.isEmpty(rounds)) {
			return []
		}
		const first = _.first(rounds);
		const last = _.last(rounds);
		const start_month = moment(first.start).month() + 1;
		const end_month = moment(last.end).month() + 1;

		return months.filter(({ val }) => {
			return val >= start_month && val <= end_month
		});
	}

	updateModel() {
		const rounds = this.rounds.recalculateCompleteRounds(true);
		const months = this.getMonthsArray(rounds);

		this.model.set({
			rounds,
			squads: this.squads.toJSON(),
			months
		});
		rankingsChannel.trigger('rankings:model:updated');

		if (this.squad_id) {
			rankingsChannel.trigger('rankings:initial_squad', this.squad_id);

			_.unset(this.squad_id);
		}

		return this;
	}

	updateCollection() {
		let actual_round = this.rounds.actual;
		if (
			actual_round &&
			actual_round.get('id')===1 &&
			actual_round.get('status')==='scheduled'
		) {
			// Fix for simulation issues
			this.collection.reset();
			this.isShowMoreButton();
		}

		return this;
	}

	isShowMoreButton(count_teams) {
		let is_load_more = count_teams >= this.rankings_limit;
		globalChannel.trigger('is:show:load:more', is_load_more);

		return this;
	}

	showMore() {
		let offset = this.model.get('offset'),
			order_direction = this.model.get('order_direction'),
			order = this.model.get('order'),
			club = this.model.get('club'),
			round = this.model.get('round'),
			month = this.model.get('month'),
			state = this.model.get('state');

		offset += this.rankings_limit;

		let data = {
			order,
			offset,
			order_direction
		};

		if (club!=='') {
			data.club = club;
		}

		if (state!=='') {
			data.state = state;
		}

		if (round) {
			data.round = round;
		}

		if (month) {
			data.month = month;
		}

		this.updateRankings(data, false);

		return this;
	}
}

export default CoreRankingsTable;